export const RECORD_ALERT_STATUS_CHANGED = 'RECORD_ALERT_STATUS_CHANGED'
export const recordAlertStatusChanged = (
  accountId: string,
  projectId: string,
  recordId: string,
  recordAlertId: string,
  status: string,
  onSuccess: () => void,
  onFailure: (error: any) => void
) => ({
  type: RECORD_ALERT_STATUS_CHANGED,
  accountId,
  projectId,
  recordId,
  recordAlertId,
  status,
  callbacks: { onSuccess, onFailure }
})

export const RECORD_ALERT_BULK_STATUS_CHANGED =
  'RECORD_ALERT_BULK_STATUS_CHANGED'
export const recordAlertBulkStatusChanged = (
  accountId: string,
  projectId: string,
  recordAlertIds: string[],
  status: string,
  onSuccess: () => void,
  onFailure: (error: any) => void
) => ({
  type: RECORD_ALERT_BULK_STATUS_CHANGED,
  accountId,
  projectId,
  recordAlertIds,
  status,
  callbacks: { onSuccess, onFailure }
})

export interface RecordAlertStatusChangedAction {
  type: typeof RECORD_ALERT_STATUS_CHANGED
  accountId: string
  projectId: string
  recordId: string
  recordAlertId: string
  status: string
  callbacks: {
    onSuccess: () => void
    onFailure: (error: any) => void
  }
}

export interface RecordAlertBulkStatusChangedAction {
  type: typeof RECORD_ALERT_BULK_STATUS_CHANGED
  accountId: string
  projectId: string
  recordAlertIds: string[]
  status: string
  callbacks: {
    onSuccess: () => void
    onFailure: (error: any) => void
  }
}
